import React from 'react';
import TourConfigBreadcrumbs from '@/features/dashboard/tourConfig/components/TourConfigBreadcrumbs.tsx';
import TourForm from '@/features/dashboard/tourConfig/components/TourForm.tsx';
import {
  TourFormData,
  TourFormInputData,
  tourSchema,
} from '@/features/dashboard/tourConfig/schemas/tourSchema.ts';
import { useTourBuilderContext } from '@/features/dashboard/tourConfig/contexts/TourBuilderContext.tsx';
import TourConfigHeader from '@/features/dashboard/tourConfig/components/TourConfigHeader.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import { useNavigate } from '@tanstack/react-router';
import TourDto from '@/features/dashboard/tourConfig/types/TourDto.ts';
import useCreateTour from '@/features/dashboard/tourConfig/hooks/useCreateTour.ts';
import TourOrganizerInsurance from '@/features/dashboard/tours/types/TourOrganizerInsurance.ts';

const CreateTourBasicsPage = () => {
  const navigate = useNavigate();

  const { mutate: createTour, isPending: isCreating } = useCreateTour();

  const { updateTourBuilderState } = useTourBuilderContext();

  const createTourForm = useForm<TourFormInputData>({
    resolver: debugZodResolver(tourSchema),
    defaultValues: {
      startDateTime: '08:00',
      endDateTime: '20:00',
      allowRegistrationDuringTour: false,
      tourOrganizerInsurance: TourOrganizerInsurance.NONE,
      destination: { country: 'PL' },
    },
  });

  const handleTourSubmit = async (tourData: TourFormData) => {
    createTour(tourData, {
      onSuccess: (tour: TourDto) => {
        updateTourBuilderState({ tour });
        navigate({ to: `/app/tours/${tour.id}/config/costs` });
      },
    });
  };

  const handleCancel = () => {
    navigate({ to: '/app/tours' });
  };

  return (
    <div className="space-y-4">
      <TourConfigBreadcrumbs />
      <FormProvider {...createTourForm}>
        <TourConfigHeader
          title={'Nowy wyjazd'}
          submit={createTourForm.handleSubmit(handleTourSubmit)}
          isLoading={isCreating}
          submitText={'Dalej'}
          onCancel={handleCancel}
        />
        <TourForm
          onSubmit={handleTourSubmit}
          isLoading={isCreating}
          isEditMode={false}
          // showSaveButton={!isEditMode || hasFormChanges}
          // showNextButton={isTourSaved && (!isEditMode || !hasFormChanges)}
        />
      </FormProvider>
    </div>
  );
};

export default CreateTourBasicsPage;
